import React from 'react'
import { MyUserGroup } from '@Scenes/RightsholderScene/RightsholderMaintenanceUserPermissionsProfile'
import CheckBox from '@Components/Selectors/Checkbox'
import { PERMISSION_NAMES } from '@App/enum/user-permissions'
import { UserGroup, UserInfo } from '@Entities/user/user'

interface MyUserGroupsMappedProps {
    myUserGroups: MyUserGroup[]
    editIsDisabled: boolean
    setMyUserGroups: (userGroups: MyUserGroup[]) => void
    rightsholderUser: UserInfo
    setEditActionsGroups: (editActionGroups: MyUserGroup[]) => void
}

const MyUserGroupsMapped = (props: MyUserGroupsMappedProps) => {
    const { myUserGroups, editIsDisabled, setMyUserGroups, rightsholderUser, setEditActionsGroups } = props

    const superUserChecked = (superUserIsChecked: boolean, newMyUserGroups: MyUserGroup[]) => {
        const myUserGroupsMapped = newMyUserGroups.map((item: MyUserGroup) => {
            const otherItemsChecked = superUserIsChecked ? false : item.checked

            return {
                ...item,
                checked: item.name === PERMISSION_NAMES.super_user ? superUserIsChecked : otherItemsChecked,
                disabled: item.name !== PERMISSION_NAMES.super_user && superUserIsChecked,
            }
        })
        setMyUserGroups(myUserGroupsMapped)
        editActionsGroupsUpdate(myUserGroupsMapped)
    }

    const editActionsGroupsUpdate = (newMyUserGroups: MyUserGroup[]) => {
        const newEditActionsGroups: MyUserGroup[] = []
        const initData = rightsholderUser
        let editActionsGroupsFiltered: MyUserGroup[]
        if (initData.groups?.length) {
            editActionsGroupsFiltered = newMyUserGroups.filter((item: MyUserGroup) => {
                const indexGroupFromPermission = initData.groups?.findIndex(
                    (group: UserGroup) => group.name === item.name
                )
                if (indexGroupFromPermission !== -1 && item.checked) {
                    return false
                } else if (indexGroupFromPermission === -1 && !item.checked) {
                    return false
                }
                return true
            })
        } else {
            editActionsGroupsFiltered = newMyUserGroups
        }
        newEditActionsGroups.push(...editActionsGroupsFiltered)
        setEditActionsGroups([...new Set(newEditActionsGroups)])
    }

    const onCheckGroup = (index: number) => {
        const newMyUserGroups = [...myUserGroups]
        newMyUserGroups[index].checked = !newMyUserGroups[index].checked
        const superUserIsChecked =
            newMyUserGroups[index].name === PERMISSION_NAMES.super_user && newMyUserGroups[index].checked
        superUserChecked(superUserIsChecked, newMyUserGroups)
    }

    return (
        <div className="permissions-group">
            {myUserGroups.map((item: MyUserGroup, index: number) => {
                if (item.name !== 'Internal User') {
                    return (
                        <CheckBox
                            key={item.name}
                            id={item.name}
                            mainColor
                            onClick={() => onCheckGroup(index)}
                            checked={item.checked}
                            text={item.name}
                            disabled={editIsDisabled ? editIsDisabled : item.disabled}
                        />
                    )
                } else {
                    return null
                }
            })}
        </div>
    )
}

export default MyUserGroupsMapped
